import axios from '../../../../utils/request';

function GET_LIST(params) {
    return axios.get("/detect/AExternalLink/index",{
        params: {
            page:params
        }
    } )
}

function SUBMIT_ADD(params) {
    return  axios.post("/detect/AExternalLink/addPost",{...params} )
}
function ADD_DATA(params) {
    return  axios.get("/detect/AExternalLink/add"  )
}
function EDIT_DATA(params) {
    return  axios.post("/detect/AExternalLink/edit",{id:params } )
}
function SUBMIT_EDIT(params) {
    return  axios.post("/detect/AExternalLink/editPost",{...params} )
}
function CHANG_STATUS (params) {
    return  axios.post("/detect/AExternalLink/statusEdit",{status:params} )
}
function DELE(params) {
    return  axios.post("/detect/AExternalLink/delete", {
            ids:params
    } )
}
function IMPORT (params) {
    return  axios.post("/detect/AExternalLink/import",{file:params} )
}
function DOWNLOAD( ) {
    return  axios.get("/detect/AExternalLink/download", )
}

export default {
    GET_LIST,
    SUBMIT_ADD,
    EDIT_DATA,
    ADD_DATA,
    SUBMIT_EDIT,
    CHANG_STATUS,
    DELE,
    DOWNLOAD

};